import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError, of } from 'rxjs';
import { environment } from '../../environments/environment';

export interface YouTubeFeedVideo {
  id: string;
  title: string;
  description: string;
  publishedAt: string;
  updatedAt: string;
  author: string;
  link: string;
  thumbnail: string;
  views: string;
}

export interface YouTubeFeedResponse {
  success: boolean;
  channelId: string;
  videos: YouTubeFeedVideo[];
  total: number;
  fetchedAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class YouTubeLiveService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Get the latest video ID from the YouTube feed
   * @returns Observable of the latest video ID or null if none found
   */
  getLatestLiveStream(): Observable<string | null> {
    return this.http.get<YouTubeFeedResponse>(`/youtube/feed`).pipe(
      map((response) => {
        if (response.success && response.videos && response.videos.length > 0) {
          // Return the ID of the first (most recent) video
          return response.videos[0].id;
        }
        return null;
      }),
      catchError((error) => {
        console.error('Error fetching latest video:', error);
        return of(null);
      })
    );
  }
}
